import React from "react";
import {Card, Statistic, Col} from "antd";
import {WalletSummaryContainer} from "./WalletSummary.styles";

export const WalletSummary = ({wallet}) => {
    return (
        <Card>
            <WalletSummaryContainer gutter={[16, 16]}>
                <Col xs={24} sm={24} md={8}>
                    <Statistic
                        title="Toplam Bakiye"
                        value={
                            wallet?.balance
                                ? wallet?.balance.toLocaleString("tr-TR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                  })
                                : ""
                        }
                        precision={2}
                        suffix="₺"
                        valueStyle={{
                            letterSpacing: "-1px",
                            fontWeight: 600
                        }}
                    />
                </Col>
                <Col xs={24} sm={24} md={8}>
                    <Statistic
                        title="Kullanılabilir Bakiye"
                        value={
                            wallet?.availableBalance
                                ? wallet?.availableBalance.toLocaleString("tr-TR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                  })
                                : ""
                        }
                        precision={2}
                        suffix="₺"
                        valueStyle={{
                            letterSpacing: "-1px",
                            fontWeight: 600
                        }}
                    />
                </Col>
                <Col xs={24} sm={24} md={8}>
                    <Statistic
                        title="Bloke Bakiye"
                        value={
                            wallet?.blockedBalance
                                ? wallet?.blockedBalance.toLocaleString("tr-TR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                  })
                                : ""
                        }
                        precision={2}
                        suffix="₺"
                        valueStyle={{
                            letterSpacing: "-1px",
                            fontWeight: 600
                        }}
                    />
                </Col>
            </WalletSummaryContainer>
        </Card>
    );
};
